import React from "react";
import { Sparkles } from "lucide-react";

/**
 * AIWhisper — a quiet, editorial container for AI-generated content.
 * NOT a chatbot bubble. Reads like a hand-written marginalia note.
 *
 * Visual: thin gold left-rule, italic accent serif, muted by default.
 */
export function AIWhisper({
  label = "Concierge note",
  children,
  loading = false,
  className = "",
  testid,
}) {
  return (
    <aside
      data-testid={testid}
      className={`relative pl-5 ${className}`}
      role="note"
    >
      <span
        aria-hidden
        className="absolute left-0 top-1 bottom-1 w-px bg-gradient-to-b from-[hsl(var(--accent-gold))]/0 via-[hsl(var(--accent-gold))]/60 to-[hsl(var(--accent-gold))]/0"
      />
      <div className="flex items-center gap-2">
        <Sparkles className="size-3 text-[hsl(var(--accent-gold))]" strokeWidth={1.5} />
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--foreground-muted))]">
          {label}
        </span>
      </div>
      <div className="mt-2 font-accent italic text-[15px] sm:text-base leading-relaxed text-[hsl(var(--foreground-secondary))]">
        {loading ? (
          <span className="inline-flex items-center gap-1.5">
            <span className="inline-block size-1 rounded-full bg-[hsl(var(--foreground-muted))]/60 animate-pulse" />
            <span className="inline-block size-1 rounded-full bg-[hsl(var(--foreground-muted))]/60 animate-pulse [animation-delay:120ms]" />
            <span className="inline-block size-1 rounded-full bg-[hsl(var(--foreground-muted))]/60 animate-pulse [animation-delay:240ms]" />
          </span>
        ) : (
          children
        )}
      </div>
    </aside>
  );
}
